/// <reference path="../_all.ts" />

module user {

  ifLoggedIn.$inject = ['userService'];
  export function ifLoggedIn(userService: user.UserService, $window): ng.IDirective {
    return {
      restrict: 'A',
      priority: 100,
      scope: false,
      link: function (scope: ILoginFormScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        var destroy = !userService.isLoggedIn();
        
        if (attr['ifLoggedIn'] === 'false') destroy = !destroy;

        if (destroy) {
          element.remove();
          element = null; 
        }
      }
    }
  }

}